<template>
  <div class="authentication">
    <v-container fluid class="pt-12 mt-12 pb-12 px-0">
      <v-container class="max-container mx-auto py-12 my-12" :class="[$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pt-12 mt-12']">
        <h3 class=" mb-2 position-relative text-center display-1 mb-6">{{ pageContent.pageTitle }}</h3>
        <v-layout row wrap align-content-center>
          <v-flex xs12 sm8 md6 lg5 xl4 mx-auto>
            <v-card class="elevation-12 mt-4">
              <v-toolbar dark color="primary" class="elevation-0">
                <v-toolbar-title v-html="!forgotPassword ? 'Inloggen' : 'Wachtwoord vergeten'"></v-toolbar-title>
              </v-toolbar>
                <form>
                  <v-card-text>
                    <v-text-field
                      prepend-icon="fas fa-user"
                      name="username"
                      label="E-mailadres"
                      type="text"
                      v-model="email"
                      :error-messages="errors.email"
                    ></v-text-field>
                    <v-text-field
                      v-if="!forgotPassword"
                      prepend-icon="fas fa-lock"
                      name="password"
                      label="Wachtwoord"
                      id="password"
                      type="password"
                      v-model="password"
                    >
                    </v-text-field>
                  </v-card-text>
                  <v-card-actions class="pa-3 white">
                    <a @click="switchForm()" v-html="forgotPassword ? 'Terug naar inloggen' : 'Wachtwoord vergeten'" style="text-decoration:underline;"></a>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary" to="" class="text-none"
                      v-html="!forgotPassword ? 'Log in' : 'Herstel wachtwoord'"
                      @click="handleClick"
                    >
                    </v-btn>
                  </v-card-actions>
                </form>
            </v-card>
          </v-flex>
      		<v-snackbar
      		  v-model="snackbar"
      		  :timeout="timeout"
      		  :color="color"

      		>
      		  {{ text }}
      		  <v-icon>{{ icon }}</v-icon>
      		</v-snackbar>
        </v-layout>
      </v-container>
    </v-container>
  </div>
</template>

<script>

export default {

  name: 'Authentication',
  data() {
    return {
      pageContent: {
        pageTitle: 'P4 Beheer',
      },
      forgotPassword: false,
      email:'',
      password:'',
      snackbar: false,
      timeout: 3000,
      errors: {},
      text: '',
      icon: '',
      color: '',
    };
  },
  created()
  {
	if(this.$store.getters.auth != false && this.$store.getters.auth != undefined){
		this.$router.push({name: 'Dashboard'});
	}
  },
  methods: {
    switchForm() {
	  this.errors = {};
      this.forgotPassword = this.forgotPassword !== true;
    },
	handleClick()
	{
		//reset password logic
		if(this.forgotPassword)
		{
			let data = {email: this.email};
			this.$store.dispatch('UserRequestPassword', data)
				.then((data) => {
					this.text = data.message;
					this.icon = 'check_circle';
					this.color = 'primary';
					this.snackbar = true;
				}).catch(error => 
				{
					this.errors = error.data.errors;
				});
		}
		//login logic
		else
		{
			let loginData = {
				grant_type:'password', 
				client_id:window.client_id, 
				client_secret:window.client_secret, 
				username: this.email, 
				password: this.password, 
				scope:'*'
			};
			this.$store.dispatch('UserLogin', loginData)
				.then(() => {
					this.$router.push({name: 'Dashboard'});
				}).catch(error => {
					this.text = 'E-mailadres en wachtwoord komen niet overeen.';
					this.snackbar = true;
					this.icon = 'error';
					this.color = 'error';
				});
		}
	}
  },
  watch:
  {
		email: {handler () { this.errors.email = undefined; }},
  }
};
</script>
